import { NumberInput } from '@mantine/core'
import {
  UseFormReturnType,
} from '@mantine/form'

import {
  DirtyFieldLabel,
  TooltipInfoProps,
} from './dirty-field'

import {
  isFieldDirty,
} from './form-dirty-utils'
import React from 'react'

interface DirtyNumberInputProps<
  T extends Record<string, any>,
> extends Omit<
  React.ComponentProps<
    typeof NumberInput
  >,
  'form' | 'label'
>, TooltipInfoProps {
  form: UseFormReturnType<T>
  field: keyof T
  label: string
}

export function DirtyNumberInput<
  T extends Record<string, any>,
>({
    form,
    field,
    label,
    ...props
  }: DirtyNumberInputProps<T>) {
  return (
    <NumberInput
      label={
        <DirtyFieldLabel
          label={label}
          changed={isFieldDirty(
            form,
            field,
          )}
        />
      }
      {...form.getInputProps(
        field as string,
      )}
      {...props}
    />
  )
}